// Materialize the same defaults the form displays, without replacing explicit
// values (including false, zero, empty strings and null) or mutating the record.
export function applySchemaDefaults(schema, data = {}) {
  const result = { ...data };
  for (const field of schema?.fields || []) {
    if (field.defaultValue === undefined) continue;
    const parts = field.key.split('.');
    if (parts.some(part => ['__proto__', 'constructor', 'prototype'].includes(part))) continue;
    let target = result;
    for (const part of parts.slice(0, -1)) {
      if (target[part] !== undefined && (target[part] === null || typeof target[part] !== 'object' || Array.isArray(target[part]))) {
        target = null;
        break;
      }
      target[part] = { ...target[part] };
      target = target[part];
    }
    const key = parts[parts.length - 1];
    if (target && target[key] === undefined) {
      target[key] = structuredClone(field.defaultValue);
    }
  }
  return result;
}
